<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    top="100px"
    width="1224px"
    :before-close="handleClose"
    class="el-pass-dialog"
  >      
      <!-- <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <el-input
            v-model="formInline.userName"
            placeholder="搜索名字"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
      </el-form> -->
      <div class="other-table">
        <el-table
          :data="tableData"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="500px"
        >
          <el-table-column prop="userName" label="姓名" min-width="80">
          </el-table-column>
          <el-table-column prop="idCardNo" label="身份证号" min-width="140">
          </el-table-column>
          <!-- <el-table-column prop="workingYear" label="工作年限" min-width="80">
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="80">
          </el-table-column> -->
          <el-table-column prop="recommendCompanyName" label="船企公司名称" min-width="140">
          </el-table-column>
          <el-table-column prop="sendTime" label="推送时间" min-width="140">
          </el-table-column>
          <el-table-column prop="auditState" label="船企审核状态" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.auditState == '1'" class="stautsClass stauts1">简历待审核</span>
              <span v-if="scope.row.auditState == '2'" class="stautsClass stauts2">简历审核通过</span>
              <span v-if="scope.row.auditState == '3'" class="stautsClass stauts3">简历审核不通过</span>
              <span v-if="scope.row.auditState == '4'" class="stautsClass stauts3">简历回退</span>
              <span v-if="scope.row.auditState == '5'" class="stautsClass stauts1">待面试</span>
              <span v-if="scope.row.auditState == '6'" class="stautsClass stauts2">面试通过</span>
              <span v-if="scope.row.auditState == '7'" class="stautsClass stauts3">面试不通过</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope.row)"
              >
                <span v-if="scope.row.auditState == '3'">简历审核不通过原因</span>
                <span v-if="scope.row.auditState == '4'">简历回退原因</span>
                <span v-if="scope.row.auditState == '7'">面试不通过原因</span>
              </el-button>
              <el-button
                v-if="scope.row.auditState == '4'"
                type="text"
                size="small"
                class="other-com"
                @click="sendInvite(scope)"
              >
                重新推送
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <unpass-list ref="unpassList"></unpass-list>
  </el-dialog>
</template>
<script>
import {
  selectAgentCyRecommendList,recommendPushAgain
} from "@/apis/index";
import unpassList from "./unpassList.vue";
// import { openFileUrl, formatFileType } from "@/utils/index";
// import { debounce } from "lodash";
// import {formatFileType} from "@/utils/index"
export default {
  components:{
    unpassList
  },
  data() {
    return {
      dialogVisible: false,
      loading:true,
      title: "",
      params: {},
      pageNation: {
      },
      tableData: [],
      userStateMap: {
        1: "在职",
        2: "离职",
        3: "公休",
      },
      formInline:{}
    };
  },
  methods: {
    showToggle(item) {
      this.pageNation = {
      },
      this.title = "推荐船员记录"
      this.dialogVisible = true;
      this.pageNation.userId = item.userId
      this.pageNation.agentCompanyId = sessionStorage.getItem("companyId")
      this.getData();
    },
    handleClose() {
      this.formInline = {}
      this.pageNation = {};
      this.dialogVisible = false;
    },
    async getData() {
      let params = this.pageNation
      params.pageNo = params.currentPage;
      const res = await selectAgentCyRecommendList(params);
      if (res.code == 1) {
        this.tableData = res.data;
        this.loading = false;
      } else {
        this.$message.error(res.msg);
      }
    },
    onSubmit(){
      this.pageNation.userName = this.formInline.userName;
      this.getData();
    },
    expendClick() {
      this.expend = !this.expend;
    },
    handleSizeChange(val) {
      this.pageNation.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNation.currentPage = val;
      this.getData();
    },
    comDetail(info){
      this.$refs.unpassList.showToggle(info);
    },
    sendInvite(scope) {
      this.$confirm("确定要重新推送吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.sendList(scope.row);
          // console.log(scope);
          this.$emit("update");
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async sendList(row) {
      let res = await recommendPushAgain({
        recommendId: row.recommendId,
      });
      if (res.code) {
        this.$message({
          message: "推送成功",
          type: "success",
        });
        this.getData();
      }

      // console.log(res);;
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}

</style>